<template>
  <tv-page title="TV标销-订单支付结果" :class="_.page">
    <template v-if="!loading">
      <div :class="_.hd">头部</div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { mapQuery, Track } from '@/utils'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: 'TV标销-订单支付结果',
      })),
      mapQuery({
        // 订单编号
        orderNo: 'orderNo',
      }),
    ],

    data: () => ({
      // 页面加载状态
      loading: true,
    }),

    mounted() {
      this.loading = false
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #1f2733;
  }

  .hd {
    color: red;
  }
</style>
